export default {
  background: {
    default: "#BFAC9B",
  },
  text: {
    main: "#7b809a",
    focus: "#7b809a",
  },
  transparent: {
    main: "transparent",
  },
  white: {
    main: "#F2EBE4",
    focus: "#F2EBE4",
  },
  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },
  primary: {
    main: "#4A4A4C",
    focus: "#4A4A4C",
  },
  secondary: {
    main: "#945B3D",
    focus: "#A36B4B",
  },
  info: {
    main: "#2F3325",
    focus: "#0E0F0B",
  },
  success: {
    main: "#32382A",
    focus: "#3F423A",
  },
  warning: {
    main: "#A36A34",
    focus: "#A6784E",
  },
  error: {
    main: "#A63935",
    focus: "#A64C49",
  },
  light: {
    main: "#E4D7CB",
    focus: "#E4D7CB",
  },
  // light: {
  //   main: "#BFAC9B",
  //   focus: "#BFAC9B",
  // },
  dark: {
    main: "#332C26",
    focus: "#26211C",
  },
  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },
  gradients: {
    primary: {
      main: "#525252",
      state: "#3B3B3D",
    },
    secondary: {
      main: "#854A3C",
      state: "#5C2721",
    },
    info: {
      main: "#3C3D38",
      state: "#2F3325",
    },
    success: {
      main: "#3E423A",
      state: "#24291E",
    },
    warning: {
      main: "#A87F4F",
      state: "#A36A34",
    },
    error: {
      main: "#A14547",
      state: "#963233",
    },
    light: {
      main: "#BFA897",
      state: "#A38B7E",
    },
    dark: {
      main: "#171717",
      state: "#000000",
    },
  },
  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#544535",
    },
    twitter: {
      main: "#55acee",
      dark: "#BA765D",
    },
    instagram: {
      main: "#125688",
      dark: "#3B1F16",
    },
    linkedin: {
      main: "#0077b5",
      dark: "#692819",
    },
    pinterest: {
      main: "#cc2127",
      dark: "#338070",
    },
    youtube: {
      main: "#e52d27",
      dark: "#3AA193",
    },
    vimeo: {
      main: "#1ab7ea",
      dark: "#9E3D34",
    },
    slack: {
      main: "#3aaf85",
      dark: "#663A51",
    },
    dribbble: {
      main: "#ea4c89",
      dark: "#51B57E",
    },
    github: {
      main: "#24292e",
      dark: "#000000",
    },
    reddit: {
      main: "#ff4500",
      dark: "#2AA0AD",
    },
    tumblr: {
      main: "#35465c",
      dark: "#171513",
    },
  },
  badgeColors: {
    primary: {
      background: "#5C5C5C",
      text: "#2B2B30",
    },
    secondary: {
      background: "#DB9B7D",
      text: "#783839",
    },
    info: {
      background: "#7A6498",
      text: "#3A373E",
    },
    success: {
      background: "#6A9C6A",
      text: "#181C13",
    },
    warning: {
      background: "#DE883B",
      text: "#463424",
    },
    error: {
      background: "#ADA2A1",
      text: "#A61611",
    },
    light: {
      background: "#A7C9C5",
      text: "#A88B7B",
    },
    dark: {
      background: "#8C8680",
      text: "#17130F",
    },
  },
  coloredShadows: {
    primary: "#4A4A4C",
    secondary: "#050D09",
    info: "#1F1D13",
    success: "#32382A",
    warning: "#A87336",
    error: "#A63935",
    light: "#877265",
    dark: "#0D0D0D",
  },
  inputBorderColor: "#d2d6da",
  tabs: {
    indicator: {
      boxShadow: "#ddd",
    },
  },
};
